import React from 'react'
import styles from './challengeBar.module.css'
const Trending =()=>{
    return(
        <div>
            
           <div className={styles.challenges}>
            <ol>
               <li>#icon_do</li>
               <br/>
               <li>#icon_do</li>
               <br/>
               <li>#icon_do</li>
               <br/>
               <li>#icon_do</li>
               <br/>
               <li>#icon_do</li>
               <br/>
               <li>#icon_do</li>
               <br/>
               <li>#icon_do</li>
               <br/>
               <li>#icon_do</li>

            </ol>
      </div>
        </div>
    )
}

export default Trending
